export const replaceEmptySpace = (
    inputString: string,
    charactersToReplace: string[],
    position: 'before' | 'after'
): string => {
    const regexPattern = charactersToReplace
        .map((char) => (position === 'before' ? `\\s${char}` : `${char}\\s`))
        .join('|')

    const regex = new RegExp(`(${regexPattern})`, 'gi') // Add 'i' flag for case-insensitivity

    const replacement =
        position === 'before'
            ? (match: string) => {
                  if (match.length > 1) {
                      return `&nbsp;${match.substring(1)}`
                  }
                  return `&nbsp;${match.charAt(1)}`
              }
            : (match: string) => {
                  if (match.length > 1) {
                      return `${match.substring(0, match.length - 1)}&nbsp;`
                  }
                  return `${match.charAt(0)}&nbsp;`
              }

    const outputString = inputString.replace(regex, replacement)

    return outputString
}
